/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Status_PausedInputs */

const en_plan_status_paused = /** @type {(inputs: Plan_Status_PausedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paused`)
};

const es_plan_status_paused = /** @type {(inputs: Plan_Status_PausedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pausada`)
};

/**
* | output |
* | --- |
* | "Paused" |
*
* @param {Plan_Status_PausedInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const plan_status_paused = /** @type {((inputs?: Plan_Status_PausedInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Status_PausedInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_plan_status_paused(inputs)
	return en_plan_status_paused(inputs)
});